// extracted by mini-css-extract-plugin
export default {"timeDiv":"unit-text_timeDiv__c7Rcu","unitText":"unit-text_unitText__Xc3Dl"};